import { useTranslation } from 'react-i18next';
import outsideLayoutRightSideImg from '../../assets/login-hero.webp';

const OutsideLayoutRightCard = () => {
  const { t } = useTranslation();

  return (
    <div className="outside_layout_right_card">
      <img
        src={outsideLayoutRightSideImg}
        className="outside_layout_right_image"
        alt="outside-layout-right-image"
      />
      <h2 className="margin_bottom font_size_30">
        {t('WORD_INTRODUCING_ORDERS_ANALYTICS')}
      </h2>
      <h3 className="text_align_center font_size_14 max_width_500px">
        {t('WORD_INTRODUCING_ORDERS_ANALYTICS_SUBTITLE')}
      </h3>
    </div>
  );
};

export default OutsideLayoutRightCard;
